import React, { useEffect, useState } from "react";
import {
  faClipboardQuestion,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Contact_details_card from "../../common_components/contact_details_card/Contact_details_card";
import { luxuryResponsibilityPolicy } from "../../../utils/luxuryapis/Home/Homeapi";

function Responsibility() {
  const [responsibiltypolicy, setResponsibiltypolicy] = useState([]);

  const getAllLuxuryResponsibilityPolicy = async () => {
    const res = await luxuryResponsibilityPolicy();
    if (res?.success) {
      setResponsibiltypolicy(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryResponsibilityPolicy();
  }, []);
  return (
    <>
      <section className="Legal_notice">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-8">
              <div className="content_box_holder">
                <div className="heading_strip_holder">
                  <h1>RESPONSIBILITY</h1>
                </div>
              </div>

              <div className="content_box_holder">
                <div className="content_holder">
                  <div className="text_holder">
                    {responsibiltypolicy.length > 0 ? (
                      responsibiltypolicy.map((item) => (
                        <div key={item.id}>
                          <p>
                            Last updated{" "}
                            {new Date(item.updatedAt).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              },
                            )}
                          </p>

                          <h4>{item.name}</h4>
                          <hr />

                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                        </div>
                      ))
                    ) : (
                      <p style={{ textAlign: "center", marginTop: "20px" }}>
                        No data found
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <Contact_details_card />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Responsibility;
